import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        {/* Left Column */}
        <div className="col-md-8 d-flex justify-content-center align-items-center">
          <img
            src="/other_images/fc_large_logo.png"
            style={{ maxHeight: "100vh", maxWidth: "100%", objectFit: "contain" }}
            alt="FinaCraft Logo"
          />
        </div>

        {/* Right Column */}
        <div className="col-md-4 d-flex justify-content-center align-items-center bg-white border-start">
          <div className="text-center w-100" style={{ maxWidth: "300px" }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
